import React from 'react';
import { Redirect } from 'react-router-dom';
import { arrayOf, bool, elementType, oneOfType, string } from 'prop-types';
import { useLoggedInUser } from '@ApplicationWide/AppConfig';
import ErrorAwareRoute from '@Generic/SaplingRoute/ErrorAwareRoute';

const AuthRoute = ({ exact, path, component: Component }) => {
  const { user } = useLoggedInUser();

  // Do not allow logged-in users to view auth routes (/login, /forgot-password, etc.)
  return (
    <ErrorAwareRoute
      exact={exact}
      path={path}
      render={(props) => (user ? <Redirect to='/' /> : <Component {...props} />)}
    />
  );
};

AuthRoute.propTypes = {
  exact: bool,
  path: oneOfType([string, arrayOf(string)]),
  component: elementType,
};

export default AuthRoute;
